import { render, staticRenderFns } from "./IWant.vue?vue&type=template&id=9462d970&scoped=true&"
import script from "./IWant.vue?vue&type=script&lang=js&"
export * from "./IWant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9462d970",
  null
  
)

export default component.exports